import * as React from 'react';
import {IconButton, Stack} from '@mui/material';
import {Delete} from '@mui/icons-material';
import {useTheme} from '@mui/styles';
import CustomTooltip from 'pages/trafficsim/trafficSimComponents/themedComponents/CustomTooltip.tsx';

export default function DeleteButton({onDelete}) {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <CustomTooltip title="Radera Begränsningar">
        {/*{' '}*/}
        <IconButton
          onClick={onDelete}
          aria-label="delete"
          size="small"
          sx={{
            backgroundColor: theme.palette.error.main,
            '&:hover': {
              backgroundColor: theme.palette.error.hover,
            },
            color: theme.palette.error.contrastText,
            textTransform: 'none',
            width: theme.spacing(3),
            height: theme.spacing(3),
            borderRadius: '3px',
          }}
        >
          <Delete fontSize="inherit" />
        </IconButton>
      </CustomTooltip>
    </Stack>
  );
}
